import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, ChevronLeft, ChevronRight, X } from "lucide-react";

export default function WizardShell({
  open, onOpenChange, title, subtitle, steps, step, setStep,
  onFinish, finishLabel = "Afronden", canNext = true, loading = false, children,
}) {
  const isLast = step === steps.length - 1;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-0 gap-0 overflow-hidden max-h-[92vh] flex flex-col" data-testid="wizard-dialog">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{subtitle || title}</DialogDescription>
        {/* Header */}
        <div className="bg-[#0F1E3D] text-white p-6 border-b-2 border-[#C9A227]">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="font-heading text-xl font-bold">{title}</h3>
              {subtitle && <p className="text-slate-300 text-sm mt-1">{subtitle}</p>}
            </div>
            <button onClick={() => onOpenChange(false)} className="text-slate-400 hover:text-white transition-colors">
              <X className="h-5 w-5" />
            </button>
          </div>
          {/* Steps */}
          <div className="flex items-center gap-2 mt-5">
            {steps.map((s, i) => (
              <div key={i} className="flex items-center gap-2 flex-1 last:flex-none">
                <div className={`wizard-step-dot flex items-center justify-center h-8 w-8 rounded-full text-xs font-bold shrink-0 ${
                  i < step ? "bg-[#C9A227] text-[#0F1E3D]" : i === step ? "bg-white text-[#0F1E3D] ring-2 ring-[#C9A227]" : "bg-white/10 text-slate-400"
                }`}>
                  {i < step ? <Check className="h-4 w-4" /> : i + 1}
                </div>
                {i < steps.length - 1 && <div className={`h-0.5 flex-1 rounded ${i < step ? "bg-[#C9A227]" : "bg-white/10"}`} />}
              </div>
            ))}
          </div>
          <div className="text-xs text-slate-400 mt-2">Stap {step + 1} van {steps.length} — {steps[step]}</div>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto flex-1">{children}</div>

        {/* Footer */}
        <div className="p-4 border-t border-slate-200 flex items-center justify-between bg-slate-50">
          <Button variant="ghost" disabled={step === 0} onClick={() => setStep(step - 1)} data-testid="wizard-prev-button">
            <ChevronLeft className="h-4 w-4 mr-1" /> Vorige
          </Button>
          {isLast ? (
            <Button onClick={onFinish} disabled={loading || !canNext} className="bg-[#C9A227] hover:bg-[#B8921F] text-[#0F1E3D] font-semibold" data-testid="wizard-finish-button">
              {loading ? "Bezig..." : (<><Check className="h-4 w-4 mr-1" /> {finishLabel}</>)}
            </Button>
          ) : (
            <Button onClick={() => setStep(step + 1)} disabled={!canNext} className="bg-[#0F1E3D] hover:bg-[#1B2D52] text-white" data-testid="wizard-next-button">
              Volgende <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
